module.exports = __webpack_public_path__ + "img/67.4d27e413.jpg";